var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.limitsRequired
        ? _c("limits-editable-table", {
            attrs: {
              "total-cost": _vm.purchase.purchase_terms.contract_price,
              "limit-year": _vm.purchase.purchase_terms.purchase_limit_year,
              "order-type": _vm.purchase.purchase_terms.order_type,
              "purchase-type": "fl44_unknown_volume",
              "purchase-id": _vm.purchase.id,
            },
            on: { validate: _vm.limitsValidate },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                        },
                        [_vm._v("Измените лимиты")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3857483780
            ),
            model: {
              value: _vm.form.limits.items,
              callback: function ($$v) {
                _vm.$set(_vm.form.limits, "items", $$v)
              },
              expression: "form.limits.items",
            },
          })
        : _vm._e(),
      _vm.limitsRequired
        ? _c("form-row-edit-supplier-accounting", {
            on: { validate: _vm.supplierAccountingValidate },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "ml-1 mt-3 mb-1 main_text font-weight-bold",
                        },
                        [_vm._v("Банковские реквизиты поставщика")]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "info",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "ml-1 fs-14" }, [
                        _vm._v(
                          "Укажите банковские реквизиты поставщика для заключения контракта, которые будут переданы в РИС после заключения."
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2408927631
            ),
            model: {
              value: _vm.form.supplier_accounting,
              callback: function ($$v) {
                _vm.$set(_vm.form, "supplier_accounting", $$v)
              },
              expression: "form.supplier_accounting",
            },
          })
        : _vm._e(),
      _c("form-row-edit-text", {
        attrs: {
          label: "Номер контракта в системе учета заказчика",
          title:
            "Укажите номер контракта в случае если он отличается от номера контракта в ИС",
          v: _vm.$v.form.customer_contract_number,
          compact: "",
        },
        model: {
          value: _vm.form.customer_contract_number,
          callback: function ($$v) {
            _vm.$set(_vm.form, "customer_contract_number", $$v)
          },
          expression: "form.customer_contract_number",
        },
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("fl44-unknown-volume-customer-sign-contract-button", {
                staticClass: "mt-3",
                attrs: {
                  purchase: _vm.purchase,
                  "is-available": !_vm.$v.$invalid,
                  form: _vm.form,
                },
                on: {
                  refresh: function ($event) {
                    return _vm.$emit("refresh")
                  },
                },
              }),
              _c("fl44-unknown-volume-sign-decline-contract-button", {
                staticClass: "ml-2",
                attrs: { "purchase-item": _vm.purchase },
                on: {
                  refresh: function ($event) {
                    return _vm.$emit("refresh")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }